import { WorldcupRoundDtoRoundCode } from '../../../api/generated/worldcup/model/worldcupRoundDtoRoundCode.ts';

export const WORLD_CUP_ROUND_ORDER = [
  WorldcupRoundDtoRoundCode.R16,
  WorldcupRoundDtoRoundCode.QF,
  WorldcupRoundDtoRoundCode.SF,
  WorldcupRoundDtoRoundCode.THIRD,
  WorldcupRoundDtoRoundCode.FINAL,
];

export const WORLD_CUP_ROUND_LABEL = {
  [WorldcupRoundDtoRoundCode.R16]: '16강',
  [WorldcupRoundDtoRoundCode.QF]: '8강',
  [WorldcupRoundDtoRoundCode.SF]: '4강',
  [WorldcupRoundDtoRoundCode.THIRD]: '3.4위',
  [WorldcupRoundDtoRoundCode.FINAL]: '결승',
};

export const WORLD_CUP_GAME_LABEL = {
  punch: '냥냥펀치',
  timeNyang: '타임냥',
  mulNyang: '물냥불냥',
};

export const WORLD_CUP_TAB_STATUS = {
  ACTIVE: 'active',
  UPCOMING: 'upcoming',
  COMPLETED: 'completed',
};

export const WORLD_CUP_CARD_STATUS = {
  LOCKED: 'locked',
  OPEN: 'open',
  CLOSED: 'closed',
  SETTLED: 'settled',
  CANCELLED: 'cancelled',
};

export const WORLD_CUP_PREDICTION_RESULT = {
  NONE: 'none',
  PICKED: 'picked',
  PENDING: 'pending',
  WON: 'won',
  LOST: 'lost',
  REFUNDED: 'refunded',
};

export const WORLD_CUP_BADGE_TONE = {
  PROGRESS: 'progress',
  SUCCESS: 'success',
  FAIL: 'fail',
  CANCEL: 'cancel',
  OPEN: 'open',
  UPCOMING: 'upcoming',
};

export const createEmptyWorldcupPageViewModel = () => ({
  event: {
    eventId: null,
    title: '월드컵 예측 이벤트',
    periodLabel: '',
    status: null,
  },
  currentRoundCode: WorldcupRoundDtoRoundCode.R16,
  activeRoundCode: null,
  tabs: WORLD_CUP_ROUND_ORDER.map((roundCode) => ({
    roundId: null,
    roundCode,
    label: WORLD_CUP_ROUND_LABEL[roundCode],
    tabStatus: WORLD_CUP_TAB_STATUS.UPCOMING,
    isActive: roundCode === WorldcupRoundDtoRoundCode.R16,
    openAt: null,
    closedAt: null,
  })),
  ticketSummary: {
    ticketBalance: 0,
    dailyLimit: 3,
    guideLines: [
      '각 게임당 티켓 1장, 매일 총 3개 획득 가능 (00:00 초기화)',
      '참여 티켓 1장당 보상금 50P 누적',
      '적중 시 누적 포인트를 티켓 수만큼 분배',
      '경기당 티켓 최대 3장까지 참여 가능',
      '예측은 경기 시작 2시간 전 마감',
    ],
    grantSources: [],
  },
  roundSections: [],
  predictionHistory: [],
});
